import { AbstractControl } from '@angular/forms';

export class CustomFormValidators {
  public static isAlphanumeric(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value) {
      const nonAlphanumericRegex = /[^a-zA-Z0-9-]/g;
      if (nonAlphanumericRegex.test(control.value)) {
        return {
          alphanumeric: true
        };
      }
    }

    return null;
  }

  public static email(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value) {

      // Regexp compliant with rfc5322 specification https://www.ietf.org/rfc/rfc5322.txt and https://emailregex.com/
      // eslint-disable-next-line max-len, no-control-regex
      const validEmailRegex =/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!validEmailRegex.test(control.value)) {
        return {
          email: true
        };
      }
    }

    return null;
  }
}
